<div class="highlightcard-list" *ngIf="!isLoading; else loadingHighlightcards">
  <div
    class="highlightcard-list__item"
    [ngClass]="{ 'highlightcard-list__item--full': columns === '1' }"
    *ngFor="let item of items"
  >
    <hdi-highlightcard
      [datatype]="type"
      [HighlightcardItems]="[item]"
    ></hdi-highlightcard>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingHighlightcards>
  <div class="highlightcard-list highlightcard-list--loader">
    <div
      class="highlightcard-list__item highlightcard-list__item--loader"
      *ngFor="let item of [].constructor(4)"
    >
      <div class="icon-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': '#dfe1e6',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="card-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': '#f9f9fa',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>
